import { Construction } from 'lucide-react'

interface ComingSoonProps {
  title: string
  description?: string
}

export function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="w-20 h-20 rounded-2xl bg-white border border-[#E2E4ED] flex items-center justify-center mb-5">
        <Construction className="w-9 h-9 text-[#555A73]" strokeWidth={1.25} />
      </div>
      <h2 className="text-xl font-bold text-[#1B2559] mb-2">{title}</h2>
      <p className="text-[#8B8FA7] text-sm max-w-md">
        {description ?? "Cette fonctionnalite arrive prochainement. Restez a l'ecoute !"}
      </p>
      <span className="mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-orion-primary-soft text-orion-primary-text text-xs font-medium">
        Bientot disponible
      </span>
    </div>
  )
}
